import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_19',
  type: NAVBAR,
  name: 'Navbar 19',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_19.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#E63D1E',editable: true},
      color: {type: 'css', value: '#FFFFFF',editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemUnderline: {type: 'custom', value: 'white', editable: true},
      navItemHoverUnderline: {type: 'custom', value: '#efb4aa', editable: true},
      navItemActiveUnderline: {type: 'custom', value: 'black', editable: true},
      navItemPadding: {type: 'custom', value: '0.5rem 2rem', editable: true},
      fontWeight: {type: 'css', value: 'Bold'},
    },
    contents: []
  }
}
